__turbopack_context__.v({
  "body": "sheet-module__P4f9lq__body",
  "foot": "sheet-module__P4f9lq__foot",
  "grabber": "sheet-module__P4f9lq__grabber",
  "panel": "sheet-module__P4f9lq__panel",
  "pill": "sheet-module__P4f9lq__pill",
  "sheet": "sheet-module__P4f9lq__sheet",
  "sheet-fade": "sheet-module__P4f9lq__sheet-fade",
  "sheet-up": "sheet-module__P4f9lq__sheet-up",
});
